const prodEnv = {
  name: "production",
  API_URL: "https://api.leanstack.co",
  CUSTOMER_URL: "https://domains.leanstack.co",
};

export default prodEnv;
